export default __webpack_public_path__ + "static/media/2.02fc8b8f.jpg";